<template>
	<div class="page_shadow page_index">
		<div class="page pdf-page" v-if="selfData">
			<div class="header">
				<span>Part1</span>基本信息
			</div>
			<h6 class="small_title">学生情况</h6>
			<div class="main_box">
				<div class="main_title">
					<span></span>
					学生
				</div>
				<ul class="student_main main">
					<li>姓名：{{selfData.n}}</li>
                    <li>性别：{{selfData.s}}</li>
					<li>学校：{{selfData.sn}}</li>
					<li>高考年份：{{selfData.by}} </li>
					<li>手机号码：{{selfData.p}}</li>
				</ul>
			</div>
			<div class="main_box">
				<div class="main_title">
					<span></span>
					家长
				</div>
				<ul class="parents_main main">
					<li>
						<p>父亲姓名：{{selfData.fn||'未填写'}}</p>
						<p>手机号码：{{selfData.fp||'未填写'}}</p>
					</li>
                    <li>
                        <p>学历：{{selfData.fe||'未填写'}}</p>
                        <p>工作单位：{{selfData.fj||'未填写'}}</p>
                    </li>
					<li>
						<p>母亲姓名：{{selfData.mn||'未填写'}}</p>
						<p>手机号码：{{selfData.mp||'未填写'}}</p>
					</li>
                    <li>
                        <p>学历：{{selfData.me||'未填写'}}</p>
                        <p>工作单位：{{selfData.mj||'未填写'}}</p>
                    </li>
				</ul>
			</div>
            <div class="main_box">
                <div class="main_title">
                    <span></span>
                    生涯测评推荐专业
                </div>
                <p class="careerBox">
                    <span v-for="(item,index) in career" :key="index">{{item.name}}</span>
                </p>
            </div>
			<div class="big_page_number"></div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'reportmessage',
	components: { },
    props: ['selfData','score','award','uData','sData','career'],
    data() {
        return {
        }
    },
    methods: {
    },
    watch: {
    },
    created() {
    },
    mounted() {

    }
}
</script>
<style type="text/css" lang='less' scoped>
	@import './report.less';
</style>